export default {
  enums: [
    { id: 'BOX' },
    { id: 'GROUP' },
    { id: 'PRODUCT_SET' },
  ]
};
